var _rect, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 95,
    height: 95,
    rx: 12,
    fill: "url(#paint0_radial_3370_7779)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.3333 33.9167V38.2917M38.75 33.9167V38.2917",
    stroke: "white",
    strokeWidth: 2.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1667 49.9584V47.7709C59.1667 42.2712 59.1667 39.5213 57.4581 37.8128C55.7496 36.1042 52.9997 36.1042 47.5 36.1042H44.5833C39.0836 36.1042 36.3338 36.1042 34.6252 37.8128C32.9167 39.5213 32.9167 42.2712 32.9167 47.7709V51.4167C32.9167 56.9164 32.9167 59.6664 34.6252 61.3748C36.3338 63.0834 39.0836 63.0834 44.5833 63.0834H46.7708",
    stroke: "white",
    strokeWidth: 2.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4167 59.4374C50.4167 59.4374 52.3832 60.1764 53.3333 63.0833C53.3333 63.0833 57.9657 55.7916 62.0833 54.3333",
    stroke: "white",
    strokeWidth: 2.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6458 43.3958H58.4375",
    stroke: "white",
    strokeWidth: 2.1875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3370_7779",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.1733 65.9267) rotate(-90) scale(65.9267 99.4785)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D9D67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.217494,
    stopColor: "#1E8157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510916,
    stopColor: "#1F6546"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.726911,
    stopColor: "#1F573E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#204533"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg3);
export default __webpack_public_path__ + "static/media/img3.56aa43d84daebbe6f76dc9c583e84043.svg";
export { ForwardRef as ReactComponent };